export default __webpack_public_path__ + "static/media/search-marker.6df57e2c.svg";